var VISIBLE_NO_OF_PAGES = 9;

$.fn.displayOnlyCurrentPageNosWithPadding = function() {
    var totalNoOfPages = parseInt($('#totalNoOfPages').text());
    var currentPage = parseInt($('#currentPageNo').text());

    $('.pageList').each(function(index) {
        var pageBeingProcessed = index + 1;  // +1 for index (0-based)
        var paddingLeftRight = Math.floor(VISIBLE_NO_OF_PAGES / 2);

        var paddingBefore = (currentPage - paddingLeftRight);
        var paddingAfter = (currentPage + paddingLeftRight);

        if (paddingBefore <= 0) {
          // not enough pages before, use space on the right
          paddingAfter = (currentPage + (paddingLeftRight + Math.abs(paddingBefore) + 1))
        }

        if (paddingAfter > totalNoOfPages) {
          // not more pages after, use space on the left
          paddingBefore = (paddingBefore - (paddingAfter - totalNoOfPages))
        }


        if (pageBeingProcessed >= paddingBefore && pageBeingProcessed <= paddingAfter) {
          $(this).show()
        }
    });
}

$.fn.populatePageNumberLinks = function() {
    var totalNoOfPages = parseInt($('#totalNoOfPages').text());
    var currentPage = parseInt($('#currentPageNo').text())

    $('.pageNumberLinks').each(function(index) {

        var currentPageUrl = window.location.href;

        var thisPageNumber = parseInt($(this).text());
        var newUrl = $.fn.updateQueryString('o', thisPageNumber, currentPageUrl);

        $(this).attr('href', newUrl)
    });
}

$.fn.rightArrowHandler = function() {
    $('.pagination_rightArrow').on('click', function() {
      // last visible page
      var lastVisiblePageNo = $('.pageList:visible').last();

      var additionalPagesRendered = 0;
      // show the next ones after the last visible page;
      lastVisiblePageNo.nextAll('.pageList:hidden').slice(0,VISIBLE_NO_OF_PAGES).each(function() {
        $(this).show();
        additionalPagesRendered++;
      });


      if (additionalPagesRendered != VISIBLE_NO_OF_PAGES) {
        // retain some of the old values
        lastVisiblePageNo.prevAll('.pageList:visible').slice((VISIBLE_NO_OF_PAGES - additionalPagesRendered - 1), VISIBLE_NO_OF_PAGES).each(function() {
           $(this).hide()
         });

      } else {
        // hide the previous ones, keep some elements if the next page didn't occupy all 9 numbers
        lastVisiblePageNo.prevAll('.pageList:visible').each(function() {
          $(this).hide()
        });
        lastVisiblePageNo.hide()  // hide self too
      }

      $.fn.hideShowLeftRightArrows();
    })
}

$.fn.leftArrowHandler = function() {
    $('.pagination_leftArrow').on('click', function() {
      // first visible page
      var firstVisiblePageNo = $('.pageList:visible').first();

      var additionalPagesRendered = 0;
      // show the next ones after the last visible page;
      firstVisiblePageNo.prevAll('.pageList:hidden').slice(0,VISIBLE_NO_OF_PAGES).each(function() {
        $(this).show();
        additionalPagesRendered++;
      });


      if (additionalPagesRendered != VISIBLE_NO_OF_PAGES) {
        // retain some of the old values
        firstVisiblePageNo.nextAll('.pageList:visible').slice((VISIBLE_NO_OF_PAGES - additionalPagesRendered -1), VISIBLE_NO_OF_PAGES).each(function() {
           $(this).hide()
         });

      } else {
        // hide the previous ones, keep some elements if the next page didn't occupy all 9 numbers
        firstVisiblePageNo.nextAll('.pageList:visible').each(function() {
          $(this).hide()
        });
        firstVisiblePageNo.hide()  // hide self too
      }

      $.fn.hideShowLeftRightArrows();
    })
}


$.fn.doubleRightArrowHandler = function() {
    $('.pagination_rightArrow_double').on('click', function() {
      // last visible page
      var lastPage = $('.pageList:hidden').last();

      // hide existing visible pages
      $('.pageList:visible').hide();

      // display last 8 pages
      lastPage.prevAll('.pageList').slice(0, 8).each(function() {
         $(this).show();
       });

       // display the last page
       lastPage.show();


      $.fn.hideShowLeftRightArrows();
    })
}

$.fn.doubleLeftArrowHandler = function() {
    $('.pagination_leftArrow_double').on('click', function() {
      // last visible page
      var firstPage = $('.pageList').first();


      // hide existing visible pages
      $('.pageList:visible').hide();

      // display last 8 pages
      firstPage.nextAll('.pageList').slice(0, 8).each(function() {
         $(this).show();
       });

       // display the first page
       firstPage.show();

      $.fn.hideShowLeftRightArrows();
    })
}


$.fn.hideShowLeftRightArrows = function() {
  var previousPages = $('.pageList:visible').first().prevAll('.pageList:hidden');
  var totalNumberOfPages = $('.pageList').length;


  if (previousPages.length != 0) {
    $('.pagination_leftArrow').show();

    if (totalNumberOfPages > 18) {
      $('.pagination_leftArrow_double').show();
    }

  } else {
    $('.pagination_leftArrow').hide()

    if (totalNumberOfPages > 18) {
      $('.pagination_leftArrow_double').hide();
    }
  }

  var nextPages = $('.pageList:visible').first().nextAll('.pageList:hidden');
  if (nextPages.length !=0) {
    $('.pagination_rightArrow').show();

    if (totalNumberOfPages > 18) {
      $('.pagination_rightArrow_double').show();
    }

  } else {
    $('.pagination_rightArrow').hide()

    if (totalNumberOfPages > 18) {
      $('.pagination_rightArrow_double').hide();
    }
  }
}

$.fn.updateQueryString = function(key, value, url) {
    if (!url) url = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;

    if (re.test(url)) {
        if (typeof value !== 'undefined' && value !== null)
            return url.replace(re, '$1' + key + "=" + value + '$2$3');
        else {
            hash = url.split('#');
            url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
            if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                url += '#' + hash[1];
            return url;
        }
    }
    else {
        if (typeof value !== 'undefined' && value !== null) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?';
            hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (typeof hash[1] !== 'undefined' && hash[1] !== null)
                url += '#' + hash[1];
            return url;
        }
        else
            return url;
    }
}

$(function() {
  $.fn.populatePageNumberLinks();
  $.fn.displayOnlyCurrentPageNosWithPadding();

  $.fn.rightArrowHandler();
  $.fn.leftArrowHandler();

  $.fn.doubleRightArrowHandler();
  $.fn.doubleLeftArrowHandler();

  $.fn.hideShowLeftRightArrows();
});